import get from 'lodash/get';

const helpers = {
  getLov: (array, lovName) => {
    if (!array || !lovName) {
      console.error('array array and lov name parameters missing');
      return [];
    }
    const lov = array.filter((o) => o.LOV_NAME === lovName);
    if (lov.length) {
      return lov[0].LOV_VALUE;
    }
    return [];
  },
  getLovsDep: (array, lovName, dependency) => {
    if (!array || !dependency || !lovName) {
      console.error('array and lov name parameters missing');
      return [];
    }
    const lov = array.filter((o) => o.LOV_NAME === lovName)[0];
    if (!lov) {
      return [];
    }
    const depField = lov.LOV_VALUE[0].DEPENDENCIES[0].NAME;
    return lov.LOV_VALUE.filter((o) => o.DEPENDENCIES[0].VALUE === dependency[depField]) || [];
  },
  getFromList: (array, value, valueToSelect, textToShow) => {
    if (!array) {
      console.error('Array is undefined');
      return 'undefined';
    }
    const valueSelect = valueToSelect || 'VALUE';
    const textShow = textToShow || 'TEXT';
    let toret = '';
    for (let i = 0; i < array.length; i++) {
      if (array[i][valueSelect] === value) {
        toret = array[i][textShow];
        break;
      }
    }
    return toret;
  },
  checkValidationRules: (array, data) => {
    if (!array || !data) {
      console.error(' rules array and data parameters missing');
      return [];
    }
    const checkNumber = Array.from(new Set(array.map((a) => a.CHECK_NUMBER)));
    // console.log(checkNumber);
    const rules = [];
    checkNumber.forEach((item) => {
      rules.push({
        CHECK_NUMBER: item,
        REFERRAL: array.filter((o) => o.CHECK_NUMBER === item).map((el) => {
          const value = get(data, el.FIELD_NAME, false);
          console.log(item, el.FIELD_NAME, value, el.FIELD_VALUE);
          // console.log(get(this.data, el.FIELD_NAME) === el.FIELD_VALUE);
          // console.log('mapping', get(this.data, el.FIELD_NAME));
          if (value === '') {
            return false;
          }
          return value === el.FIELD_VALUE;
        }).every((el) => el === true)
      });
    });
    console.log(rules);
    const toret = {
      RULES: rules.reduce((acc, { CHECK_NUMBER, REFERRAL }) => {
        if (REFERRAL) {
          acc.push(CHECK_NUMBER);
        }
        return acc;
      }, []),
      REFERRAL: !!rules.filter((o) => o.REFERRAL).length
    };
    console.log(toret);
    return toret;
  }
};

export default helpers;
